import {useMutation} from '@apollo/react-hooks';

import type {
    AddSubdomain as AddSubdomainMutation,
    AddSubdomainVariables as AddSubdomainMutationVariables,
    SubdomainAddInput,
} from 'nutshell-graphql-types';

import ADD_SUBDOMAIN from '../mutations/add-subdomain.graphql';

export function useAddSubdomain(): {
    addSubdomain: (arg1: SubdomainAddInput) => Promise<any>;
    isAdding: boolean;
    error: string | null | undefined;
} {
    const [addSubdomain, {loading, error}] = useMutation<
        AddSubdomainMutation,
        AddSubdomainMutationVariables
    >(ADD_SUBDOMAIN);

    const errorMessage = error ? error.message : undefined;

    return {
        addSubdomain: (input: SubdomainAddInput) =>
            addSubdomain({
                variables: {subdomainAdd: input},
            }),
        isAdding: loading,
        error: errorMessage,
    };
}
